import { h } from 'preact';
import styled from 'styled-components';
import { Typography } from '@authentic/loyalty-pwa/util';

interface NavLinkProps {
  id?: string;
  url?: string;
  label: string;
  active: boolean;
}

const Link = styled.a<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-style: normal;
  color: black;
  text-decoration: none;
  white-space: nowrap;
  letter-spacing: 0.1px;
  margin: 0;
  padding: 11px;
  font-weight: ${(props: { isActive: boolean }) => (props.isActive ? 'bold' : 'normal')};
  ${(props) =>
    props.isActive &&
    `
    border-bottom: 2px solid black;
  `}
  &:hover {
    border-bottom: 2px solid black;
  }
`;

export const NavLink = ({ id, url, label, active }: NavLinkProps) => {
  return (
    <Link href={url} id={id} isActive={active}>
      {' '}
      <Typography variant="body2">{label}</Typography>
    </Link>
  );
};
